import React from 'react';

import { Button, Paper } from '@material-ui/core';
import MaterialTable from 'material-table';
import DotIcon from '@material-ui/icons/Lens';
import { createStyles, Theme, withStyles } from '@material-ui/core/styles';

import commonStyles from '../../common/common.module.css';
import driverStyles from './driverQueue.module.css';

import fdLogo from '../../../assets/fd_text_logo.png';
import PickupOrderGha from '../../../models/PickupOrderGha';
import moment from 'moment';
import { formatCurrency } from '../../../utils/currencyFormatter';

const styles = (theme: Theme) =>

  createStyles({
    green: {
      color: 'green',
      fontSize: '14px'
    },
    orderMT: {
      width: '100%',
    },
    detailsWrapper: {
      display: 'flex',
      fontSize: '13px',
      '& > p': {
        marginTop: 0
      }
    },
    title: {
      width: '50%',
      minWidth: '120px',
      marginRight: '10px'
    },
    orderTable: {
      '& table': {
        padding: '0 12px !important'
      },
      '& thead': {
        display: 'none !important'
      },
    },
  });

const PADDING_RIGHT_CELLS = '14px';
const PADDING_LEFT_CELLS = '10px';
const cellStyle = { paddingRight: PADDING_RIGHT_CELLS, paddingLeft: PADDING_LEFT_CELLS };
const headerStyle = { paddingRight: PADDING_RIGHT_CELLS, paddingLeft: PADDING_LEFT_CELLS };

interface OrderDetailsPageProps {
  classes: any;
  ghaName: string;
  changeScreen: Function;
  po: PickupOrderGha;
  handleSave: (type: string) => void;
};

const orderDetailsPage = (props: OrderDetailsPageProps) => {

  const { classes, po } = props;

  return (
    <div className={driverStyles.pageWrapper}>
      <div className={driverStyles.logoWrapper}>
        <img alt="frontline dynamics logo" src={fdLogo} className={driverStyles.logoImg} />
        <div className={driverStyles.ghaName}>{props.ghaName} </div>
      </div>

      <div className={driverStyles.content}>
        <div className={` ${commonStyles.wrapper} ${classes.orderMT} `}>
          <div>
            <h3 className={commonStyles.header}> Order #{po.number} <DotIcon className={classes.green} /></h3>
            <div className={classes.detailsWrapper}>
              <p className={classes.title}>{po.order_type == 'do' ? 'Drop Off:' : 'Pick Up:'}</p>
              <p className={classes.data}>{`${moment(po.pickup_date).format('DDMMMYY').toUpperCase()} ${po.pickup_time}`}</p>
            </div>
            <div className={classes.detailsWrapper}>
              <p className={classes.title}>Forwarder:</p>
              <p className={classes.data}>{po.forwarder_company_name}</p>
            </div>
            <div className={classes.detailsWrapper}>
              <p className={classes.title}>Trucking Company:</p>
              <p className={classes.data}>{po.delivery_company_name}</p>
            </div>
            <div className={classes.detailsWrapper}>
              <p className={classes.title}>Driver:</p>
              <p className={classes.data}>{po.driver_name}</p>
            </div>
          </div>
          <div className={commonStyles.mt3}>
            <h3 className={commonStyles.header}> List of Awbs </h3>
            <MaterialTable

              components={{ Container: props => <Paper {...props} elevation={0} className={`${commonStyles.paperTable} ${classes.orderTable}`} /> }}

              data={props.po.list}

              columns={[
                {
                  title: 'Awb', field: 'awb', cellStyle, headerStyle,
                  render: (rowData) => {
                    return <div>{rowData.code + '-' + rowData.number}</div>;
                  }
                },
                {
                  title: 'Pcs', field: 'pieces', cellStyle, headerStyle,
                  render: (rowData) => {
                    return <div>{rowData.pieces + 'Pcs'}</div>;
                  }
                },
                {
                  title: 'Amount', field: 'amount', cellStyle: { minWidth: '100px', maxWidth: '150px', textAlign: 'right' }, headerStyle, hidden: props.po.order_type == 'do',
                  render: (rowData) => {
                    return <div>{ formatCurrency(rowData.due, 2, '$') }</div>;
                  }
                },
              ]}

              options={{
                paging: false,
                pageSize: 10,
                headerStyle: {
                  backgroundColor: 'var(--tbl_head_bkg)',
                  color: 'var(--tbl_head_color)',
                  zIndex: 2,
                  display: 'none'
                },
                maxBodyHeight: 'calc(100vh - 74vh)',
                showTitle: false,
                pageSizeOptions: [15, 20],
                toolbar: false,
                sorting: false
              }}
            />
           { po.due && <div className={driverStyles.totalWrapper}><span className={driverStyles.totalContent}>Total Due <span className={driverStyles.totalAmt}>{formatCurrency(po.due, 2, '$')}</span></span></div>}
          </div>
        </div>
      </div>
      <div className={driverStyles.footer}>

        <div className={commonStyles.fSpaceBtw}>
          <Button
            color="primary"
            variant="contained"
            className={` ${driverStyles.button} ${driverStyles.redButton} `}
            onClick={() => props.changeScreen('appointment')}
          >
            Go back
          </Button>
          <Button
            color="primary"
            variant="contained"
            className={` ${driverStyles.button} `}
            onClick={() => props.handleSave('appointment')}
          >
            Check In
          </Button>
        </div>
      </div>
    </div>
  );
}

export default withStyles(styles)(orderDetailsPage);